import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateUiAction } from 'actions/uiActions'
import { updateMarkupAction, deleteMarkupAction } from 'actions/markupActions'
import { messageAction } from 'actions/messageActions'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'
import { FillPicker, BorderPicker } from './ColorPicker'

const mapStateToProps = ({ map: { markups }, currentEntity: { id } }) => {
  return { currentMarkup: markups.find(m => m.id === id) }
}

class MarkupDetails extends React.Component {
  computeBounds = (type, overlay) => {
    if (type === 'rectangle' || type === 'circle') return overlay.getBounds()

    let bounds = new google.maps.LatLngBounds()
    overlay.getPath().getArray().forEach(latLng => bounds.extend(latLng))
    return bounds
  }

  render() {
    const { computeBounds, props: { currentMarkup, currentMarkup: { id, locked, type, overlay, remove }, updateUiAction,
      updateMarkupAction, deleteMarkupAction, classes } } = this
    const title = capitalizeFirstLetter(type)

    return (
      <div className={classes.markupDetails}>
        <div className={classes.topUiControls}>
          <a onClick={_ => updateUiAction({ sidebarView: 'cameraList' })}>
            <FontAwesomeIcon icon='caret-left' className={classes.goBackButton} />
            All Project Items
          </a>
          <a
            onClick={_ => {
              if (locked) {
                this.props.messageAction('generalError', `Cannot delete locked ${title}. Right click to unlock.`)
              } else {
                remove()
                deleteMarkupAction(id)
              }
            }}
            className={classes.destroyMarkupButton}>
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </a>
        </div>
        <div className={classes.container}>
          <span style={{ flex: '1 1 auto' }}>{ `Edit ${title}` }</span>
          <a onClick={_ => overlay.map.fitBounds(computeBounds(type, overlay))} >
            <FontAwesomeIcon icon='map-marker-alt' className={classes.targetButton} />
          </a>
          <a onClick={_ => updateMarkupAction(id, { locked: !locked })}>
            <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} className={classes.lockButton} />
          </a>
        </div>
        { type !== 'polyline' && type !== 'wall' &&
          <div className={classes.container}>
            <span>Fill</span>
            <FillPicker {...{ currentMarkup, updateMarkupAction }} />
          </div>
        }
        <div className={classes.container}>
          <span>
            { type === 'polyline' || type === 'wall' ? 'Color' : 'Border' }
          </span>
          <BorderPicker {...{ currentMarkup, updateMarkupAction }} />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, updateMarkupAction, deleteMarkupAction, messageAction })(injectSheet(style)(MarkupDetails))



// WEBPACK FOOTER //
// ./src/components/MarkupDetails/index.js